import moment from 'moment'

function getMoren(formData) {
  console.log('个案---------', JSON.stringify(formData.need_help_person_name))
  // || `个案--${formData.need_help_person_name || moren}`
  // var str = null
  var returnVal = `个案--${formData.need_help_person_name || ''}`
  // if (formData.process_base_title && formData.process_base_title.indexOf('undefined') === -1) {
  //   str = ''
  //   returnVal = formData.process_base_title
  // } else {
  //   if (formData.need_help_person_name === undefined) {
  //     returnVal = formData.process_base_title
  //   } else {
  //     str = `个案--${formData.need_help_person_name}`
  //     returnVal = str
  //   }
  // }

  return returnVal
}

export const forms = {
  getBaseForm(formData, extend, pageType) {
    var moren = ''
    if (pageType === 'launch' || pageType === 'draft' || pageType === 'relaunch') {
      moren = ''
    } else {
      moren = '--'
    }
    const getType = (name, type) => {
      if (extend.checkDisabled(name)) {
        return 'text'
      } else {
        return type
      }
    }
    const data = [
      {
        type: getType('process_base_title', 'input'), // getType('process_base_title', 'input')
        label: '业务事项',
        col: '12',
        lineFeed: true,
        defaultValue: getMoren(formData),
        disabled: true,
        id: 'process_base_title',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('individual_case_apply_time', 'datePicker'),
        label: '申请时间',
        // disabled: extend.checkDisabled,
        lineFeed: true,
        rules: [
          {
            required: true,
            message: '请选择申请时间'
          }
        ],
        format: 'YYYY-MM-DD',
        defaultValue: extend.checkDisabled('individual_case_apply_time')
          ? formData.individual_case_apply_time
            ? `${formData.individual_case_apply_time}`
            : ''
          : formData.individual_case_apply_time
            ? moment(formData.individual_case_apply_time, 'YYYY-MM-DD')
            : null,
        col: '12',
        id: 'individual_case_apply_time',
        layout: {
          labelCol: '120px'
        }
      },
      {
        type: getType('individual_case_instructions', 'textarea'),
        label: '申请理由',
        rules: [
          {
            required: true,
            message: '请填写申请理由'
          }
        ],
        col: '24',
        lineFeed: true,
        autoSize: { minRows: 5, maxRows: 20 },
        defaultValue: formData.individual_case_instructions || moren,
        id: 'individual_case_instructions',
        layout: {
          labelCol: '120px'
        }
      }

    ]
    return data
  }
}
